export default "__VITE_ASSET__9512672f__"